import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentUser } from 'features/auth/ducks/selectors'
import { getJumpTargets } from 'services/BpService'

let cache = null

export const resetMyBuildingsCache = () => { cache = null }

const cachedFor = userId => (userId && cache && cache.userId === userId ? cache.rows : null)

const useMyBuildings = (enabled = true) => {
  const currentUser = useSelector(getCurrentUser)
  const userId = currentUser?.id || null
  const [state, setState] = useState(() => ({ userId, rows: cachedFor(userId) || [], loading: enabled && !cachedFor(userId) }))

  useEffect(() => {
    if (!enabled || !userId) return undefined
    const hit = cachedFor(userId)
    if (hit) {
      setState({ userId, rows: hit, loading: false })
      return undefined
    }
    let live = true
    setState({ userId, rows: [], loading: true })
    getJumpTargets()
      .then(res => {
        const rows = (res?.data?.data || [])
          .filter(row => row.type === 'bp')
          .map(row => ({ value: row.id, label: row.name || 'Unnamed Building Passport' }))
          .sort((a, b) => a.label.localeCompare(b.label))
        cache = { userId, rows }
        if (live) setState({ userId, rows, loading: false })
      })
      .catch(() => { if (live) setState({ userId, rows: [], loading: false }) })
    return () => { live = false }
  }, [enabled, userId])

  const current = state.userId === userId
  return {
    buildings: current ? state.rows : [],
    loading: enabled && (!current || state.loading || !userId),
  }
}

export default useMyBuildings
